module.exports = __webpack_public_path__ + "img/tooltip_bottom.d08378fa.svg";